"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FullBar = function FullBar(props) {
  var propNames = ['left', 'middle', 'right'];

  //Top bar
  var left = Array.isArray(props.left) ? props.left.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "fullBarLeft-".concat(index),
      className: "item fullBarLetItem"
    }, element);
  }) : props.left;
  var middle = Array.isArray(props.middle) ? props.middle.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "fullBarMiddle-".concat(index),
      className: "item fullBarMiddleItem"
    }, element);
  }) : props.middle;
  var right = Array.isArray(props.right) ? props.right.map(function (element, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "fullBarRight-".concat(index),
      className: "item fullBarRightItem"
    }, element);
  }) : props.right;
  var contentPropUsed = Object.keys(props).filter(function (propName) {
    return propNames.includes(propName);
  });
  var hasMultiple = contentPropUsed.length > 1;
  var dynamicClasses = {
    "multipleCol": hasMultiple
  };
  if (contentPropUsed.length !== 0) dynamicClasses[contentPropUsed[0]] = !hasMultiple;
  var modalClasses = (0, _classnames["default"])("fullBar-component", props.className, dynamicClasses);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: modalClasses
  }, left && /*#__PURE__*/_react["default"].createElement("div", {
    className: "left"
  }, left), middle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "middle"
  }, middle), right && /*#__PURE__*/_react["default"].createElement("div", {
    className: "right"
  }, right));
};
FullBar.propTypes = {
  left: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  middle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  right: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].object]),
  className: _propTypes["default"].string
};
FullBar.defaultProps = {};
var _default = exports["default"] = FullBar;